import React, { memo } from "react";
import { LandingWrapper, Wrapper } from "../styles/components/PLP/Global";
import { DatoKeyValuesMap } from "../data/DatoContentData";

const Section = memo(({ datoContentData }) => {
  const findComponentByKey = key => {
    const section = DatoKeyValuesMap.find(section => section.key === key);
    return section ? section.component : null;
  };

  return (
    <LandingWrapper className="landing-wrapper">
      {datoContentData?.map((contentItem, index) => {
        const SectionComponent = findComponentByKey(contentItem.key);
        if (!SectionComponent) return null;
        return (
          <Wrapper key={contentItem.id} className={contentItem.key + " active"}>
            <SectionComponent key={contentItem.id} {...contentItem.content} />
          </Wrapper>
        );
      })}
    </LandingWrapper>
  );
});

export default Section;
